// extracted by mini-css-extract-plugin
export default {"category":"SelectCategory_category__V912U","categoryList":"SelectCategory_categoryList__qFUwv"};